import { useCallback, useEffect, useRef, useState } from "react";
import portraitImage from "../assets/achen1.jpg";
import appShotOne from "../assets/App1.jpg";
import appShotTwo from "../assets/App2.jpg";
import appShotThree from "../assets/App3.jpg";
import resumePdf from "../assets/ChengHuangCV.pdf";
import aumLogo from "../assets/aumLogo.png";
import Reveal from "../components/Reveal";
import UabLogo from "../components/UabLogo";
import classes from "./Home.module.css";

const SwiftLogo = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-252 343.9 106.1 106.1"
    aria-label="Swift logo"
    className={className}
  >
    <path
      fill="#F05138"
      d="M-145.9,373.3c0-1.1,0-2.1,0-3.2c-0.1-2.3-0.2-4.7-0.6-7c-0.4-2.3-1.1-4.5-2.2-6.6c-1.1-2.1-2.4-4-4.1-5.6
		c-1.7-1.7-3.6-3-5.6-4.1c-2.1-1.1-4.3-1.8-6.6-2.2c-2.3-0.4-4.6-0.6-7-0.6c-1.1,0-2.1,0-3.2,0c-1.3,0-2.5,0-3.8,0h-28.1h-11.6
		c-1.3,0-2.5,0-3.8,0c-1.1,0-2.1,0-3.2,0c-0.6,0-1.2,0-1.7,0.1c-1.7,0.1-3.5,0.2-5.2,0.5c-1.7,0.3-3.4,0.8-5,1.4
		c-0.5,0.2-1.1,0.5-1.6,0.7c-1.6,0.8-3,1.8-4.4,2.9c-0.4,0.4-0.9,0.8-1.3,1.2c-1.7,1.7-3,3.6-4.1,5.6c-1.1,2.1-1.8,4.3-2.2,6.6
		c-0.4,2.3-0.5,4.6-0.6,7c0,1.1,0,2.1,0,3.2c0,1.3,0,2.5,0,3.8v17.3v22.4c0,1.3,0,2.5,0,3.8c0,1.1,0,2.1,0,3.2
		c0.1,2.3,0.2,4.7,0.6,7c0.4,2.3,1.1,4.5,2.2,6.6c1.1,2.1,2.4,4,4.1,5.6c1.7,1.7,3.6,3,5.6,4.1c2.1,1.1,4.3,1.8,6.6,2.2
		c2.3,0.4,4.6,0.6,7,0.6c1.1,0,2.1,0,3.2,0c1.3,0,2.5,0,3.8,0h39.7c1.3,0,2.5,0,3.8,0c1.1,0,2.1,0,3.2,0c2.3-0.1,4.7-0.2,7-0.6
		c2.3-0.4,4.5-1.1,6.6-2.2c2.1-1.1,4-2.4,5.6-4.1c1.7-1.7,3-3.6,4.1-5.6c1.1-2.1,1.8-4.3,2.2-6.6c0.4-2.3,0.6-4.6,0.6-7
		c0-1.1,0-2.1,0-3.2c0-1.3,0-2.5,0-3.8v-39.7C-145.9,375.8-145.9,374.6-145.9,373.3z"
    />
    <path
      fill="#FFFFFF"
      d="M-168,409.4c0.1-0.4,0.2-0.8,0.3-1.2c4.4-17.5-6.3-38.3-24.5-49.2c8,10.8,11.5,23.9,8.4,35.3
		c-0.3,1-0.6,2-1,3c-0.4-0.3-0.9-0.6-1.6-0.9c0,0-18.1-11.2-37.7-30.9c-0.5-0.5,10.5,15.7,22.9,28.8c-5.9-3.3-22.2-15.2-32.6-24.6
		c1.3,2.1,2.8,4.2,4.4,6.1c8.6,11,19.9,24.5,33.4,34.9c-9.5,5.8-22.9,6.3-36.2,0c-3.3-1.5-6.4-3.4-9.3-5.5
		c5.6,9,14.3,16.8,24.9,21.4c12.6,5.4,25.2,5.1,34.5,0.1l0,0c0,0,0.1,0,0.1-0.1c0.4-0.2,0.8-0.5,1.2-0.7c4.5-2.3,13.3-4.6,18.1,4.6
		C-161.3,432.6-158.8,420.6-168,409.4C-168,409.4-168,409.4-168,409.4z"
    />
  </svg>
);

const ReactLogo = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-11.5 -10.23174 23 20.46348"
    aria-label="React logo"
    className={className}
  >
    <circle cx="0" cy="0" r="2.05" fill="#61dafb" />
    <g stroke="#61dafb" strokeWidth="1" fill="none">
      <ellipse rx="11" ry="4.2" />
      <ellipse rx="11" ry="4.2" transform="rotate(60)" />
      <ellipse rx="11" ry="4.2" transform="rotate(120)" />
    </g>
  </svg>
);

const ArduinoLogo = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    preserveAspectRatio="xMidYMid"
    fill="#00979c"
    aria-label="Arduino logo"
    className={className}
  >
    <path d="M23.783 23.55c-2.044 0-3.8-.7-5.33-2.1-.95-.87-1.733-1.937-2.454-3.046-.72 1.1-1.504 2.175-2.454 3.046-1.653 1.515-3.547 2.197-5.8 2.087C3.476 23.52 0 20.143 0 15.994c0-4.16 3.495-7.544 7.8-7.544a8.51 8.51 0 0 1 6.05 2.378c.826.77 1.524 1.66 2.16 2.593.636-.933 1.334-1.824 2.16-2.593a8.51 8.51 0 0 1 6.05-2.378c4.296 0 7.8 3.384 7.8 7.544 0 4.148-3.476 7.526-7.755 7.544a9.39 9.39 0 0 1-.462.011zm-6.22-7.656c.853 1.383 1.68 2.67 2.688 3.594 1.138 1.043 2.337 1.472 3.887 1.4l.07-.002c2.827 0 5.128-2.2 5.128-4.88s-2.3-4.88-5.128-4.88a5.88 5.88 0 0 0-4.236 1.665c-.912.848-1.665 1.935-2.408 3.116zM7.8 11.113c-2.827 0-5.128 2.2-5.128 4.88s2.3 4.88 5.128 4.88l.07.002c1.55.082 2.75-.347 3.887-1.4 1.008-.924 1.836-2.2 2.688-3.594-.744-1.18-1.497-2.268-2.408-3.116C10.817 11.63 9.47 11.1 7.8 11.1zm16.762 3.914v-1.444H23.06v1.444h-1.444v1.496h1.444v1.455h1.503v-1.455h1.444v-1.496h-1.444M5.628 15h4.746v1.542H5.628z" />
  </svg>
);

const projects = [
  {
    title: "It's Time",
    caption: "iOS reminder app",
    summary:
      "Simple, clean, reminder application. More functions is on the way( Like A.I.). Download it now from iOS App Store. (100% free)",
    image: appShotOne,
    images: [appShotOne, appShotTwo, appShotThree],
    featuredPreview: true,
    meta: "SwiftUI • Core Data • App Store",
    link: "https://apps.apple.com/cn/app/its-time-just-a-reminder/id6476443485?l=en-GB",
    cta: "Open App Store",
  },
  {
    title: "Portfolio",
    caption: "Personal website",
    summary:
      "This is my personal website, recording my experience and life, hopefully, get you into my view a little bit.",
    image: appShotTwo,
    featuredPortfolio: true,
    meta: "React • Animation • Liquid Glass",
    link: resumePdf,
    cta: "View Resume",
  },
  {
    title: "Smart Stove Detector",
    caption: "Internet of Things",
    summary:
      "A solution could solve the itchy about people thinking whether they turned off their stove when they are out.",
    image: appShotThree,
    featuredStove: true,
    meta: "Homekit • Arduino • Smart Home",
    link: "",
    cta: "Coming Soon",
  },
];

const experience = [
  {
    years: "2022 - 2023",
    title: "Instructor",
    organization: "Auburn University at Montgomery",
    description:
      "Taught 3D modeling and database concepts while translating technical topics into practical, student-friendly lessons.",
  },
  {
    years: "2021 - 2022",
    title: "Graduate Teaching Assistant",
    organization: "Auburn University at Montgomery",
    description:
      "Supported courses across frontend, cloud, C++, and MySQL, with a focus on helping students build confidence and ship work.",
  },
];

const strengths = [
  "Frontend interfaces that feel calm, clear, and intentional",
  "Visual storytelling across web, 3D, and product design",
  "Teaching experience that sharpens communication and collaboration",
];

const heroHighlights = [
  {
    label: "M.S. Computer Science",
    hoverType: "logo",
    hoverLogo: aumLogo,
    hoverAlt: "Auburn University at Montgomery logo",
    hoverLogoClassName: classes.highlightLogoMark,
  },
  {
    label: "M.S. Electrical and Computer Engineering",
    hoverType: "svg",
  },
  {
    label: "Instructor",
    hoverType: "logo",
    hoverLogo: aumLogo,
    hoverAlt: "Auburn University at Montgomery logo",
    hoverLogoClassName: classes.highlightLogoMark,
  },
  {
    label: "App Developer",
    hoverType: "tools",
    hoverTools: [
      { kind: "svg", component: SwiftLogo, label: "Swift logo" },
      { kind: "svg", component: ReactLogo, label: "React logo" },
      { kind: "svg", component: ArduinoLogo, label: "Arduino logo" },
    ],
  },
];

const profileFacts = [
  { label: "Background", value: "Computer Science, Teaching" },
  { label: "Style", value: "Minimal, Creative, Further" },
  { label: "Tools", value: "React, SwiftUI, Blender, Arduino" },
];

const experienceSignals = [
  { label: "Strength", value: "Explaining technical ideas clearly" },
  { label: "Built through", value: "Teaching, frontend work, design thinking" },
  { label: "Best at", value: "Turning complexity into usable experiences" },
];

const contactSignals = [
  { label: "Availability", value: "Open to web development and iOS development roles" },
  { label: "Best fit", value: "Front-end, swift, data" },
  { label: "Response", value: "Email-first and resume ready" },
];

const fields = [
  "Full-stack Web",
  "iOS Development",
  "Machine Learning",
  "Computer Vision",
  "3D Modeling",
  "Internet of Things",
];

const sectionThemes = ["hero", "about", "projects", "experience", "contact"];
const rotatingHeroWords = [
  "See",
  "Hear",
  "Find",
  "Hire",
  "Feature",
  "Wait",
  "Control",
  "Burn",
];

const Home = () => {
  const sectionRefs = useRef({});
  const heroRef = useRef(null);
  const resumeButtonRef = useRef(null);
  const reminderPreviewRef = useRef(null);
  const portfolioPreviewRef = useRef(null);
  const stovePreviewRef = useRef(null);
  const [activeTheme, setActiveTheme] = useState("hero");
  const [isResumeMounted, setIsResumeMounted] = useState(false);
  const [isResumeExpanded, setIsResumeExpanded] = useState(false);
  const [isResumeClosing, setIsResumeClosing] = useState(false);
  const [isResumeControlsVisible, setIsResumeControlsVisible] = useState(false);
  const [resumeMorphStyle, setResumeMorphStyle] = useState({});
  const [heroWordIndex, setHeroWordIndex] = useState(0);
  const [incomingHeroWord, setIncomingHeroWord] = useState(null);
  const [isHeroWordTransitioning, setIsHeroWordTransitioning] = useState(false);
  const isAboutSectionActive = activeTheme === "about";
  const [reminderPreviewIndex, setReminderPreviewIndex] = useState(0);
  const [isReminderPreviewVisible, setIsReminderPreviewVisible] =
    useState(false);
  const [isPortfolioPreviewVisible, setIsPortfolioPreviewVisible] =
    useState(false);
  const [isStovePreviewVisible, setIsStovePreviewVisible] = useState(false);

  useEffect(() => {
    document.body.dataset.theme = activeTheme;

    return () => {
      delete document.body.dataset.theme;
    };
  }, [activeTheme]);

  useEffect(() => {
    const observedSections = Object.values(sectionRefs.current);

    if (!observedSections.length) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort(
            (first, second) =>
              second.intersectionRatio - first.intersectionRatio,
          );

        if (!visibleEntries.length) {
          return;
        }

        const nextTheme = visibleEntries[0].target.dataset.themeSection;

        if (nextTheme) {
          setActiveTheme(nextTheme);
        }
      },
      {
        threshold: [0.2, 0.4, 0.6],
        rootMargin: "-18% 0px -18% 0px",
      },
    );

    observedSections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const rotationInterval = window.setInterval(() => {
      const nextIndex = (heroWordIndex + 1) % rotatingHeroWords.length;

      setIncomingHeroWord(rotatingHeroWords[nextIndex]);
      setIsHeroWordTransitioning(true);

      window.setTimeout(() => {
        setHeroWordIndex(nextIndex);
        setIncomingHeroWord(null);
        setIsHeroWordTransitioning(false);
      }, 320);
    }, 2200);

    return () => window.clearInterval(rotationInterval);
  }, [heroWordIndex]);

  useEffect(() => {
    if (!isReminderPreviewVisible) {
      return undefined;
    }

    setReminderPreviewIndex(0);

    const previewInterval = window.setInterval(() => {
      setReminderPreviewIndex((currentIndex) => (currentIndex + 1) % 3);
    }, 1800);

    return () => window.clearInterval(previewInterval);
  }, [isReminderPreviewVisible]);

  useEffect(() => {
    if (!reminderPreviewRef.current) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsReminderPreviewVisible(Boolean(entry?.isIntersecting));
      },
      {
        threshold: 0.55,
        rootMargin: "0px 0px -6% 0px",
      },
    );

    observer.observe(reminderPreviewRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!portfolioPreviewRef.current) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsPortfolioPreviewVisible(Boolean(entry?.isIntersecting));
      },
      {
        threshold: 0.55,
        rootMargin: "0px 0px -6% 0px",
      },
    );

    observer.observe(portfolioPreviewRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!stovePreviewRef.current) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsStovePreviewVisible(Boolean(entry?.isIntersecting));
      },
      {
        threshold: 0.55,
        rootMargin: "0px 0px -6% 0px",
      },
    );

    observer.observe(stovePreviewRef.current);

    return () => observer.disconnect();
  }, []);

  const registerSection = (theme) => (node) => {
    if (node) {
      sectionRefs.current[theme] = node;
    }
  };

  const sectionStateClass = (theme) =>
    activeTheme === theme ? classes.sectionActive : classes.sectionInactive;

  const measureResumeButton = () => {
    if (!heroRef.current || !resumeButtonRef.current) {
      return null;
    }

    const heroRect = heroRef.current.getBoundingClientRect();
    const buttonRect = resumeButtonRef.current.getBoundingClientRect();

    return {
      top: `${buttonRect.top - heroRect.top}px`,
      left: `${buttonRect.left - heroRect.left}px`,
      width: `${buttonRect.width}px`,
      height: `${buttonRect.height}px`,
      borderRadius: "999px",
    };
  };

  const openResumePanel = useCallback(() => {
    if (window.innerWidth <= 768) {
      window.open(resumePdf, "_blank", "noopener,noreferrer");
      return;
    }

    const nextStyle = measureResumeButton();

    if (!nextStyle) {
      window.open(resumePdf, "_blank", "noopener,noreferrer");
      return;
    }

    setResumeMorphStyle(nextStyle);
    setIsResumeMounted(true);
    setIsResumeClosing(false);
    setIsResumeControlsVisible(false);

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        setIsResumeExpanded(true);
      });
    });

    window.setTimeout(() => {
      setIsResumeControlsVisible(true);
    }, 260);
  }, []);

  const closeResumePanel = useCallback(() => {
    const nextStyle = measureResumeButton();

    if (nextStyle) {
      setResumeMorphStyle(nextStyle);
    }

    setIsResumeClosing(true);
    setIsResumeControlsVisible(false);
    setIsResumeExpanded(false);

    window.setTimeout(() => {
      setIsResumeMounted(false);
      setIsResumeClosing(false);
    }, 520);
  }, []);

  useEffect(() => {
    if (!isResumeMounted) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeResumePanel();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [closeResumePanel, isResumeMounted]);

  return (
    <>
      <div
        className={`${classes.scene} ${
          classes[
            `theme${activeTheme.charAt(0).toUpperCase()}${activeTheme.slice(1)}`
          ]
        }`}
      >
        <div className={classes.moodBackdrop} aria-hidden="true">
          {sectionThemes.map((theme) => (
            <div
              key={theme}
              className={`${classes.moodLayer} ${
                activeTheme === theme ? classes.moodLayerActive : ""
              } ${classes[`mood${theme.charAt(0).toUpperCase()}${theme.slice(1)}`]}`}
            />
          ))}
        </div>

        <main className={classes.page}>
          <Reveal
            as="section"
            className={`${classes.shell} ${classes.hero} ${sectionStateClass("hero")}`}
            elementRef={registerSection("hero")}
            data-theme-section="hero"
            ref={undefined}
          >
            <div className={classes.heroInner} ref={heroRef}>
              <div className={classes.heroCopy}>
                <div className={classes.heroCopyTop}>
                  <p className={classes.eyebrow}>Cheng Huang • Achen</p>
                  <h1
                    aria-label={`Can You ${rotatingHeroWords[heroWordIndex]} Me?`}
                  >
                    <span className={classes.heroHeadlineLine}>Can</span>
                    <span className={classes.heroHeadlineLine}>You</span>
                    <span className={classes.heroHeadlineLine}>
                      <span className={classes.heroWordSwap}>
                        <span
                          className={`${classes.heroWord} ${
                            isHeroWordTransitioning
                              ? classes.heroWordAnimated
                              : ""
                          } ${
                            isHeroWordTransitioning
                              ? classes.heroWordExiting
                              : ""
                          }`}
                        >
                          {rotatingHeroWords[heroWordIndex]}
                        </span>
                        {incomingHeroWord && (
                          <span
                            className={`${classes.heroWord} ${classes.heroWordAnimated} ${classes.heroWordEntering}`}
                          >
                            {incomingHeroWord}
                          </span>
                        )}
                      </span>
                    </span>
                    <span className={classes.heroHeadlineLine}>Future?</span>
                  </h1>
                </div>
                <div className={classes.heroCopyBottom}>
                  <p className={classes.lead}>
                    A.I. is taking most of us. What I can do? Seeing the future,
                    and making it arrive now.
                  </p>
                  <div className={classes.highlightRow}>
                    {heroHighlights.map((item) => (
                      <span key={item.label} className={classes.highlightPill}>
                        <span className={classes.highlightLabel}>
                          {item.label}
                        </span>
                        <span
                          className={classes.highlightHover}
                          aria-hidden="true"
                        >
                          {item.hoverType === "logo" && (
                            <img
                              src={item.hoverLogo}
                              alt={item.hoverAlt}
                              className={`${classes.highlightLogo} ${
                                item.hoverLogoClassName || ""
                              }`.trim()}
                            />
                          )}
                          {item.hoverType === "badge" && (
                            <span className={classes.highlightBadge}>
                              {item.hoverBadge}
                            </span>
                          )}
                          {item.hoverType === "svg" && (
                            <span className={classes.highlightSvgWrap}>
                              <UabLogo />
                            </span>
                          )}
                          {item.hoverType === "tools" && (
                            <span className={classes.highlightToolRow}>
                              {item.hoverTools.map((tool) => {
                                if (tool.kind === "svg") {
                                  const ToolIcon = tool.component;

                                  return (
                                    <span
                                      key={tool.label}
                                      className={classes.highlightToolIconWrap}
                                    >
                                      <ToolIcon
                                        className={classes.highlightToolIcon}
                                      />
                                    </span>
                                  );
                                }

                                return (
                                  <span
                                    key={tool.label}
                                    className={classes.highlightBadge}
                                  >
                                    {tool.label}
                                  </span>
                                );
                              })}
                            </span>
                          )}
                        </span>
                      </span>
                    ))}
                  </div>
                  <div className={classes.ctaRow}>
                    <a
                      className={classes.primaryCta}
                      href="mailto:achenloveswork@gmail.com"
                    >
                      Contact me
                    </a>
                    <button
                      type="button"
                      className={`${classes.secondaryCta} ${
                        isResumeMounted ? classes.resumeButtonActive : ""
                      }`}
                      onClick={openResumePanel}
                      ref={resumeButtonRef}
                    >
                      View resume
                    </button>
                  </div>
                </div>
              </div>

              <div className={classes.heroVisual}>
                <div className={classes.portraitFrame}>
                  <img
                    src={portraitImage}
                    alt="Portrait of Cheng Huang"
                    className={classes.portrait}
                  />
                </div>
                <div className={classes.heroNote}>
                  <span className={classes.noteLabel}>Field</span>
                  <div className={classes.notePillGrid}>
                    {fields.map((field) => (
                      <span key={field} className={classes.notePill}>
                        {field}
                      </span>
                    ))}
                  </div>
                </div>
                <div className={classes.heroNote}>
                  <span className={classes.noteLabel}>Research</span>
                  <p>Wrinkled photo deformation system</p>
                </div>
              </div>
              {isResumeMounted && (
                <div
                  className={`${classes.heroResumeOverlay} ${
                    isResumeExpanded ? classes.heroResumeOverlayOpen : ""
                  }`}
                  aria-hidden={!isResumeExpanded}
                >
                  <div
                    className={`${classes.heroResumePanel} ${
                      isResumeExpanded ? classes.heroResumePanelExpanded : ""
                    }`}
                    style={resumeMorphStyle}
                  >
                    <div className={classes.resumePanelTop}>
                      <div
                        className={`${classes.resumePanelHeader} ${
                          !isResumeControlsVisible || isResumeClosing
                            ? classes.resumePanelHeaderHidden
                            : ""
                        }`}
                      >
                        <span className={classes.noteLabel}>Resume</span>
                      </div>
                      <button
                        type="button"
                        className={`${classes.resumeCloseButton} ${
                          !isResumeControlsVisible || isResumeClosing
                            ? classes.resumeCloseButtonHidden
                            : ""
                        }`}
                        onClick={closeResumePanel}
                        aria-label="Close resume preview"
                      >
                        X
                      </button>
                    </div>
                    <div className={classes.resumeViewerWrap}>
                      <iframe
                        className={`${classes.resumeViewer} ${
                          isResumeExpanded ? classes.resumeViewerVisible : ""
                        }`}
                        src={resumePdf}
                        title="Cheng Huang resume preview"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Reveal>

          <Reveal
            as="section"
            className={`${classes.shell} ${classes.section} ${sectionStateClass("about")}`}
            delay={80}
            elementRef={registerSection("about")}
            data-theme-section="about"
          >
            <div className={classes.sectionIntro}>
              <p className={classes.eyebrow}>About</p>
              <h2>You Should Know.</h2>
            </div>
            <div className={classes.aboutGrid}>
              <article className={`${classes.glassCard} ${classes.storyCard}`}>
                <span className={classes.noteLabel}>Short story</span>
                <h3>
                  From teaching technical subjects to shaping cleaner digital
                  experiences.
                </h3>
                <p>
                  I finished a master&apos;s degree in computer science at
                  Auburn University at Montgomery, then stayed on to teach
                  technical subjects. That path made me care about structure,
                  clarity, and making complex ideas feel intuitive.
                </p>
                <div
                  className={`${classes.storyTrack} ${
                    isAboutSectionActive ? classes.storyTrackVisible : ""
                  }`}
                  aria-hidden="true"
                >
                  <span className={classes.storyTrackLabel}>Study</span>
                  <span className={classes.trackLine}></span>
                  <span className={classes.storyTrackLabel}>Teach</span>
                  <span className={classes.trackLine}></span>
                  <span className={classes.storyTrackLabel}>Build</span>
                </div>
              </article>
              <div className={classes.aboutSide}>
                <div className={classes.factGrid}>
                  {profileFacts.map((fact) => (
                    <article key={fact.label} className={classes.factCard}>
                      <span>{fact.label}</span>
                      <strong>{fact.value}</strong>
                    </article>
                  ))}
                </div>
                <div className={classes.strengthList}>
                  {strengths.map((item, index) => (
                    <article key={item} className={classes.strengthCard}>
                      <span>{`0${index + 1}`}</span>
                      <p>{item}</p>
                    </article>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal
            as="section"
            className={`${classes.shell} ${classes.section} ${sectionStateClass("projects")}`}
            delay={140}
            elementRef={registerSection("projects")}
            data-theme-section="projects"
          >
            <div className={classes.sectionIntro}>
              <p className={classes.eyebrow}>Projects</p>
              <h2>I Made Them.</h2>
            </div>
            <div className={classes.projectGrid}>
              {projects.map((project) => (
                <article
                  key={project.title}
                  className={`${classes.projectCard} ${
                    project.featuredPreview ? classes.projectCardFeatured : ""
                  }`}
                >
                  <div
                    className={`${classes.projectImageWrap} ${
                      project.featuredPreview
                        ? classes.projectImageWrapFeatured
                        : ""
                    } ${
                      project.featuredPreview && isReminderPreviewVisible
                        ? classes.projectImageWrapFeaturedActive
                        : ""
                    }`}
                    ref={
                      project.featuredPreview ? reminderPreviewRef : undefined
                    }
                  >
                    {project.featuredPreview ? (
                      <div
                        className={classes.projectPreviewStage}
                        aria-hidden="true"
                      >
                        <div
                          className={`${classes.previewStack} ${
                            isReminderPreviewVisible
                              ? classes.previewStackVisible
                              : ""
                          }`}
                        >
                          <div className={classes.previewGlow}></div>
                          <div className={classes.previewFrame}>
                            {project.images.map((image, index) => (
                              <img
                                key={image}
                                src={image}
                                alt=""
                                className={`${classes.previewImage} ${
                                  reminderPreviewIndex === index
                                    ? classes.previewImageActive
                                    : ""
                                }`}
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                    ) : project.featuredPortfolio ? (
                      <div
                        className={`${classes.portfolioPreview} ${
                          isPortfolioPreviewVisible
                            ? classes.portfolioPreviewVisible
                            : ""
                        }`}
                        ref={portfolioPreviewRef}
                        aria-hidden="true"
                      >
                        <div className={classes.browserMockup}>
                          <div className={classes.browserChrome}>
                            <div className={classes.browserTrafficLights}>
                              <span></span>
                              <span></span>
                              <span></span>
                            </div>
                            <div className={classes.browserAddressBar}>
                              achenworld.com
                            </div>
                          </div>
                          <div className={classes.browserCanvas}>
                            <div className={classes.browserHeroCopy}>
                              <span className={classes.browserEyebrow}>
                                Cheng Huang • Achen
                              </span>
                              <strong>
                                <span>Can</span>
                                <span>You</span>
                                <span>{rotatingHeroWords[heroWordIndex]}</span>
                                <span>Future?</span>
                              </strong>
                              <div className={classes.browserTagRow}>
                                <span>React</span>
                                <span>Animation</span>
                                <span>Liquid Glass</span>
                              </div>
                            </div>
                            <div className={classes.browserArtCluster}>
                              <div className={classes.browserPortraitChip}>
                                <img
                                  src={portraitImage}
                                  alt=""
                                  className={classes.browserPortraitImage}
                                />
                              </div>
                              <div className={classes.browserGlowOrb}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : project.featuredStove ? (
                      <div
                        className={`${classes.stovePreview} ${
                          isStovePreviewVisible
                            ? classes.stovePreviewVisible
                            : ""
                        }`}
                        ref={stovePreviewRef}
                        aria-hidden="true"
                      >
                        <div className={classes.stoveScene}>
                          <div className={classes.stoveTop}>
                            <div className={classes.stoveBurnerGlow}></div>
                            <div className={classes.stoveKnobBase}>
                              <div className={classes.stoveKnobFace}>
                                <span
                                  className={classes.stoveKnobIndicator}
                                ></span>
                              </div>
                              <div className={classes.stoveSmartRing}>
                                <span className={classes.stoveRingLight}></span>
                              </div>
                            </div>
                          </div>
                          <div className={classes.stoveAlertCard}>
                            <span className={classes.stoveAlertLabel}>
                              Safety Alert
                            </span>
                            <strong>Stove still on</strong>
                            <p>Make sure you turn it off before you leave home.</p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <img
                        src={project.image}
                        alt={`${project.title} preview`}
                        className={classes.projectImage}
                      />
                    )}
                  </div>
                  <div className={classes.projectCopy}>
                    <p className={classes.projectCaption}>{project.caption}</p>
                    <h3>{project.title}</h3>
                    <p>{project.summary}</p>
                    <div className={classes.projectFooter}>
                      <span>{project.meta}</span>
                      <a href={project.link} target="_blank" rel="noreferrer">
                        {project.cta}
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </Reveal>

          <Reveal
            as="section"
            className={`${classes.shell} ${classes.section} ${sectionStateClass("experience")}`}
            delay={180}
            elementRef={registerSection("experience")}
            data-theme-section="experience"
          >
            <div className={classes.sectionIntro}>
              <p className={classes.eyebrow}>Experience</p>
              <h2>Just Keep Scrolling.</h2>
            </div>
            <div className={classes.experienceGrid}>
              <article
                className={`${classes.glassCard} ${classes.experienceLeadCard}`}
              >
                <span className={classes.noteLabel}>What it built</span>
                <h3>
                  Teaching became a foundation for better product communication.
                </h3>
                <p>
                  Working with students made me more precise about flow,
                  clarity, pacing, and how people actually understand technical
                  systems. That same thinking now shapes how I design and build
                  interfaces.
                </p>
                <div className={classes.signalGrid}>
                  {experienceSignals.map((item) => (
                    <article key={item.label} className={classes.signalCard}>
                      <span>{item.label}</span>
                      <strong>{item.value}</strong>
                    </article>
                  ))}
                </div>
              </article>
              <div className={classes.experienceTimeline}>
                {experience.map((item) => (
                  <article key={item.title} className={classes.timelineCard}>
                    <div className={classes.timelineRail} aria-hidden="true">
                      <span className={classes.timelineDot}></span>
                      <span className={classes.timelineStem}></span>
                    </div>
                    <div className={classes.timelineCopy}>
                      <p className={classes.experienceYears}>{item.years}</p>
                      <h3>{item.title}</h3>
                      <p className={classes.organization}>
                        {item.organization}
                      </p>
                      <p>{item.description}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal
            as="section"
            className={`${classes.shell} ${classes.contactSection} ${sectionStateClass("contact")}`}
            delay={220}
            elementRef={registerSection("contact")}
            data-theme-section="contact"
          >
            <div className={classes.contactCopy}>
              <p className={classes.eyebrow}>Contact</p>
              <h2>Connect or what?</h2>
              <p>
                The fastest way to reach me is by email. Resume and GitHub stay
                one click away if you want to review more detail.
              </p>
              <div className={classes.signalGrid}>
                {contactSignals.map((item) => (
                  <article key={item.label} className={classes.signalCard}>
                    <span>{item.label}</span>
                    <strong>{item.value}</strong>
                  </article>
                ))}
              </div>
            </div>
            <div className={classes.contactPanel}>
              <div className={classes.contactBadgeRow}>
                <span className={classes.availabilityBadge}>
                  Available for work
                </span>
                <span className={classes.contactHint}>
                  Email is the fastest route
                </span>
              </div>
              <div className={classes.contactActions}>
                <a
                  className={classes.primaryCta}
                  href="mailto:achenloveswork@gmail.com"
                >
                  achenloveswork@gmail.com
                </a>
                <a
                  className={classes.secondaryCta}
                  href={resumePdf}
                  target="_blank"
                  rel="noreferrer"
                >
                  Download resume
                </a>
                <a
                  className={classes.secondaryCta}
                  href="https://github.com/Achennn?tab=repositories"
                  target="_blank"
                  rel="noreferrer"
                >
                  GitHub
                </a>
              </div>
            </div>
          </Reveal>
        </main>
      </div>
    </>
  );
};

export default Home;
